export const SEARCHING_CUSTOMER_DETAILS = "SEARCHING_CUSTOMER_DETAILS";
export const SET_CUSTOMER_DETAILS = "SET_CUSTOMER_DETAILS";
export const SET_CUSTOMER_NAME = "SET_CUSTOMER_NAME";
export const LOADING_CUSTOMERS = "LOADING_CUSTOMERS";
export const SET_CUSTOMERS = "SET_CUSTOMERS";
